import { Link } from "react-router-dom";
import { Plus, CheckCircle2, Circle, MapPin } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { MapPicker } from "@/components/MapPicker";
import { AddressFields } from "@/components/Fields";
import { LabelPicker } from "@/components/AddressForm";
import { LABEL_ICON } from "@/pages/Addresses";

export const pickAddress = (a) => ({ address_id: a.address_id, address: a.address, landmark: a.landmark || "", lat: a.lat, lng: a.lng });

export const NewAddress = ({ form, set, canSave }) => {
  const { t } = useApp();
  return (
    <div className="space-y-4" data-testid="new-address-form">
      <MapPicker lat={form.lat} lng={form.lng} autoDetect onChange={(lat, lng) => set({ lat, lng })} />
      <AddressFields form={form} set={set} />
      {canSave && (
        <div className="space-y-2">
          <label className="flex items-center gap-2 text-sm font-semibold text-[#0D3B2B]">
            <input type="checkbox" checked={form.save_address !== false} onChange={(e) => set({ save_address: e.target.checked })} className="h-5 w-5 accent-[#2E9E6B]" data-testid="save-address-checkbox" />
            {t("Save this address for next time")}
          </label>
          {form.save_address !== false && <LabelPicker value={form.address_label || "Other"} onChange={(address_label) => set({ address_label })} />}
        </div>
      )}
    </div>
  );
};

const Option = ({ on, onClick, Icon, title, sub, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`flex w-full items-start gap-3 rounded-2xl border-2 bg-white p-3 text-left transition-colors ${on ? "border-[#2E9E6B] bg-[#2E9E6B]/5" : "border-[#D2E0D8]"}`}>
    <Icon className="mt-0.5 h-5 w-5 shrink-0 text-[#2E9E6B]" />
    <span className="min-w-0 flex-1"><span className="block font-bold text-[#0D3B2B]">{title}</span>{sub && <span className="block text-sm text-[#4A6358]">{sub}</span>}</span>
    {on ? <CheckCircle2 className="h-5 w-5 shrink-0 text-[#2E9E6B]" /> : <Circle className="h-5 w-5 shrink-0 text-[#D2E0D8]" />}
  </button>
);

export const AddressChooser = ({ addrs, form, set }) => {
  const { t } = useApp();
  const isNew = form.address_id === "new";
  return (
    <div className="space-y-3" data-testid="address-chooser">
      {addrs.map((a) => (
        <Option key={a.address_id} on={form.address_id === a.address_id} onClick={() => set(pickAddress(a))} Icon={LABEL_ICON[a.label] || MapPin}
          title={`${t(a.label)}${a.is_default ? ` · ${t("Default")}` : ""}`} sub={`${a.address}${a.landmark ? ` · ${a.landmark}` : ""}`} testid={`choose-address-${a.address_id}`} />
      ))}
      <Option on={isNew} Icon={Plus} title={t("Use a different address")} testid="choose-address-new"
        onClick={() => set({ address_id: "new", address: "", landmark: "", lat: null, lng: null, save_address: true, address_label: "Other" })} />
      {isNew && <NewAddress form={form} set={set} canSave />}
      <Link to="/profile/addresses" className="block text-center text-sm font-semibold text-[#2E9E6B]" data-testid="manage-addresses-link">{t("Manage my addresses")}</Link>
    </div>
  );
};
